import { HttpClient, HttpParams } from '@angular/common/http';
import { map } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var DuplicatesCheckService = /** @class */ (function () {
    function DuplicatesCheckService(http) {
        this.http = http;
    }
    DuplicatesCheckService.prototype.queryDuplicatesChecking = function (params, dealerId) {
        this.requestParams = new HttpParams()
            .set('reportType', String(params.reportType))
            .set('reportDate', params.reportDate)
            .set('sellerId', String(params.sellerId));
        return this.http
            .get("dealers/" + (dealerId ? dealerId : 'mine') + "/reports/check-duplication/", { headers: { 'Content-Type': 'application/json' }, params: this.requestParams })
            .pipe(map(function (response) {
            return response;
        }));
    };
    DuplicatesCheckService.ngInjectableDef = i0.defineInjectable({ factory: function DuplicatesCheckService_Factory() { return new DuplicatesCheckService(i0.inject(i1.HttpClient)); }, token: DuplicatesCheckService, providedIn: "root" });
    return DuplicatesCheckService;
}());
export { DuplicatesCheckService };
